export const examples = [
  {
    title: "Fire and Ice",
    text: `Some say the world will end in fire, Some say in ice. From what I’ve
  tasted of desire, I hold with those who favor fire. But if it had to
  perish twice, I think I know enough of hate, To say that for
  destruction ice is also great, And would suffice.`,
    author: "by Robert Frost",
    freeAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/english_free.mp3",
    premiumAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/english_premium.mp3",
  },
  {
    title: "La Plaza Tiene una Torre",
    text: `La plaza tiene una torre,
  la torre tiene un balcón,
  el balcón tiene una dama,
  la dama una blanca flor.
  
  Ha pasado un caballero,
  ¡quién sabe por qué pasó!,
  y se ha llevado la plaza
  con su torre y su balcón,
  con su balcón y su dama
  su dama y su blanca flor.`,
    freeAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/spanish_free.mp3",
    premiumAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/spanish_premium.mp3",
    author: "Antonio Machado",
  },
  {
    title: "狐狸和老虎",
    text: `在茂密的大森林里，一只饥饿的老虎逮住了一只狐狸。老虎张开大嘴就要把狐狸吃掉。
    “慢着”！狐狸虽然很害怕但还是装出一副很神气的样子说，“你知道我是谁吗？我可是玉皇大帝派来管理百兽的兽王，
    你要是吃了我，玉皇大帝是决不会放过你的`,
    author: "未知",
    freeAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/mandarin_free.mp3",
    premiumAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/mandarin_premium.mp3",
  },
  {
    title: "जाने वाले क्या कभी लौट कर भी आते हैं",
    text: `जाने वाले क्या कभी लौट कर भी आते हैं
    छोड़ गए थे जिसे क्या उसे वापस अपना बनाते हैं
    
    जाने का मन तो वो बहुत पहले बनाते हैं
    फिर क्यों किसी को बताकर नहीं जाते हैं
    
    जाने वाले क्या कभी लौट कर भी आते हैं
    छोड़ गए थे जिसे क्या उसे वापस अपना बनाते हैं`,
    author: "Nupoor Kumari",
    freeAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/hindi_free.mp3",
    premiumAudio:
      "https://storage.googleapis.com/audiobook-310902.appspot.com/hindi_premium.mp3",
  },
];
